import { render, staticRenderFns } from "./videoType.vue?vue&type=template&id=421a4122&"
import script from "./videoType.vue?vue&type=script&lang=js&"
export * from "./videoType.vue?vue&type=script&lang=js&"
import style0 from "./videoType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "videoType.vue"
export default component.exports